import { render, staticRenderFns } from "./modal-plant-detail.component.vue?vue&type=template&id=77645159&scoped=true&"
import script from "./modal-plant-detail.component.vue?vue&type=script&lang=js&"
export * from "./modal-plant-detail.component.vue?vue&type=script&lang=js&"
import style0 from "./modal-plant-detail.component.vue?vue&type=style&index=0&id=77645159&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77645159",
  null
  
)

export default component.exports